/* tslint:disable */
/* eslint-disable */
/**
 * My App API
 * My App API description
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    MailTemplateType,
    MailTemplateTypeFromJSON,
    MailTemplateTypeFromJSONTyped,
    MailTemplateTypeToJSON,
    Purpose,
    PurposeFromJSON,
    PurposeFromJSONTyped,
    PurposeToJSON,
} from './';

/**
 * 
 * @export
 * @interface MailTemplate
 */
export interface MailTemplate {
    /**
     * 
     * @type {Date}
     * @memberof MailTemplate
     */
    createdAt: Date;
    /**
     * 
     * @type {number}
     * @memberof MailTemplate
     */
    version: number;
    /**
     * 
     * @type {Date}
     * @memberof MailTemplate
     */
    updatedAt: Date;
    /**
     * 
     * @type {number}
     * @memberof MailTemplate
     */
    id?: number;
    /**
     * 
     * @type {Purpose}
     * @memberof MailTemplate
     */
    purpose: Purpose;
    /**
     * 
     * @type {MailTemplateType}
     * @memberof MailTemplate
     */
    type?: MailTemplateType;
    /**
     * 
     * @type {string}
     * @memberof MailTemplate
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof MailTemplate
     */
    subject: string;
    /**
     * 
     * @type {string}
     * @memberof MailTemplate
     */
    body: string;
    /**
     * 
     * @type {string}
     * @memberof MailTemplate
     */
    signature: string;
}

export function MailTemplateFromJSON(json: any): MailTemplate {
    return MailTemplateFromJSONTyped(json, false);
}

export function MailTemplateFromJSONTyped(json: any, ignoreDiscriminator: boolean): MailTemplate {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'createdAt': (new Date(json['createdAt'])),
        'version': json['version'],
        'updatedAt': (new Date(json['updatedAt'])),
        'id': !exists(json, 'id') ? undefined : json['id'],
        'purpose': PurposeFromJSON(json['purpose']),
        'type': !exists(json, 'type') ? undefined : MailTemplateTypeFromJSON(json['type']),
        'name': json['name'],
        'subject': json['subject'],
        'body': json['body'],
        'signature': json['signature'],
    };
}

export function MailTemplateToJSON(value?: MailTemplate | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'createdAt': (value.createdAt.toISOString()),
        'version': value.version,
        'updatedAt': (value.updatedAt.toISOString()),
        'id': value.id,
        'purpose': PurposeToJSON(value.purpose),
        'type': MailTemplateTypeToJSON(value.type),
        'name': value.name,
        'subject': value.subject,
        'body': value.body,
        'signature': value.signature,
    };
}


